import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IPage } from '@core/interfaces/ipage';
import { PageService } from '@core/services/page.service';

import { Editor, toHTML, Toolbar } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';

@Component({
    selector: 'app-front-page',
    templateUrl: './front-page.component.html',
    styleUrls: ['./front-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FrontPageComponent implements OnInit {
  constructor(
    private page: PageService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {}
  editor!: Editor;

  form!: FormGroup | any;

  maxTitleOfCharacters = 100;
  numberOfTitleCharacters = 0;

  maxNumberOfDescripCharacters = 500;
  numberOfDescripCharacters = 0;

  pageContent!: IPage | null;

  toolbar: Toolbar = [
    ['bold', 'italic', 'underline'],
    // ['underline'],
    // ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    // @todo: Racca - modify toolbar settings 
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    // ['link', 'image'],
    // ['text_color', 'background_color'],
    // ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  get PageTitle() {
    return this.form.get('pageTitle');
  }
  get EditorContent() {
    return this.form.get('editorContent');
  }

  ngOnInit(): void {
    this.initForm();
    this.editor = new Editor();

    this.initInput();
  }

  initForm() {
    this.form = this.fb.group({
      pageTitle: [null, [Validators.required, Validators.maxLength(100)]],
      editorContent: [null, [Validators.required, Validators.maxLength(500)]],
    });
  }

  initInput(): void {
    this.page
      .getPageById(40) // @todo: we need to update so that we don't hardcode this number, query for the 
      .pipe(take(1))
      .subscribe((res: any) => {
        this.pageContent = res;
        this.form.patchValue({
          pageTitle: res.title,
          editorContent: res.body,
        });
      });
  }

  onSubmit(): void {
    const payload: IPage = {
      id: this.pageContent?.id ?? 0,
      title: this.PageTitle.value,
      body:
        typeof this.EditorContent.value == 'string'
          ? this.EditorContent.value
          : toHTML(this.EditorContent.value),
      menuItemId: this.pageContent?.menuItemId,
    };
    var formData = new FormData();
    formData.append('page', JSON.stringify(payload));

    if (!this.pageContent) {
      this.page.updatePage(payload).pipe(take(1)).subscribe();
    } else {
      this.page
        .updatePage(payload)
        .pipe(take(1))
        .subscribe((res) => {
          if (!res) {
            this.toastr.success('Changes have been updated.');
          }
        });
    }
  }
  updateChanges(): void {
    this.page
      .getPageById(40) // here too
      .pipe(take(1))
      .subscribe((res: IPage) => {
        if (!res) {
          this.toastr.error('No Page Found.');
          this.pageContent = res;
          this.PageTitle.setValue(null);
          this.EditorContent.setValue(null);
          return;
        }
        this.pageContent = res;
        this.PageTitle.setValue(res.title);
        this.EditorContent.setValue(res.body);

        this.PageTitle.markAsPristine();
        this.EditorContent.markAsPristine();
      });
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  titleCount(event: any): void {
    this.numberOfTitleCharacters = event.target.value.length;

    if (this.numberOfTitleCharacters > this.maxTitleOfCharacters) {
      event.target.value = event.target.value.slice(
        0,
        this.maxTitleOfCharacters - 1
      );
      this.numberOfTitleCharacters = this.maxTitleOfCharacters;
    }
  }

  descriptionCount(event: any): void {
    this.numberOfDescripCharacters = event.target.value.length;

    if (this.numberOfDescripCharacters > this.maxNumberOfDescripCharacters) {
      event.target.value = event.target.value.slice(
        0,
        this.maxNumberOfDescripCharacters -1
      );
      this.numberOfDescripCharacters = this.maxNumberOfDescripCharacters;
    }
  }
}
